import styled from 'styled-components';

export const EbonSelectorContainer = styled.div`
    display: flex;
    flex-direction: column;

    .loading-div {
        width: 100%;
    }

    .button-add {
        display: flex;
        justify-content: center;
        margin: 20px 10px 0 10px;

        &.validateCart .bt {
            background-color: ${props => props.theme.partnerCardEbonValidateCartBackgroundColor};
            color: ${props => props.theme.partnerCardEbonValidateCartTextColor};
            border-color: ${props => props.theme.partnerCardEbonValidateCartBorderColor};
        }
    }

    @media (min-width: ${props => props.theme.mobile}) {
        flex-direction: row;
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/merchantcard/ebonselector/EbonSelectorComponentStyle.js